import { api } from "../app/api.js";
import { store } from "../app/store.js";
import { display_errors } from "../helpers/forms.js";

export default {
    template: `
        <div class="hero hero-1 home">
            <div class="content">
                <h1 class="shatter">King<br/>Earthquake</h1>
                <p class="offline">
                    Tune into our weekly radio shows on KETV<br/>
                </p>
                <a href="#ketv-timetable" class="offline"><button id="HeroButton">Timetable</button></a>
                <p class="online hidden">
                    Tune into our weekly radio shows on KETV<br/>
                </p>
                <a href="/ketv" class="online hidden"><button id="HeroButton">Watch Now</button></a>
            </div>
            <div class="live hidden">
                <button>Listen</button>
                <span>Live</span>
            </div>
            <i id="ScrollDown" class="scoll-down fa fa-chevron-down"></i>
        </div>
        <div id="ketv-timetable" class="section home lighter-1">
            <h2>KETV Radio</h2>
            <p class="center">Join Errol Arawak on his own radio shows multiple times a week. Tune in at home or on the go.</p>
            
            <div class="schedule">
                <div class="schedule-column">
                    <h3>Legendary SoundChat</h3>
                    <p class="time">SUNDAYS 6pm - 9pm</p>
                    <p>
                        Legendary Soundchat brings together Errol Arawak and Quaker City in conversation with Veteran Soundmen.
                        Each session shares real journeys from foundation to present day. Covering sound
                        building, music and deeper reasoning behind the culture. A space rooted in history, knowledge and memories. 
                    </p>
                </div>
                <div class="schedule-column">
                    <h3>Strictly Old Skool Roots &amp; Culture Vinyl Night</h3>
                    <p class="time">MONDAYS 8pm - 10pm</p>
                    <p>
                        Start your week with vintage Roots & Culture. Foundation tunes that will uplift your mind and
                        spirit that will take you on a positive journey to see you through the week. Come and enjoy the
                        friendly atmosphere with like-minded people.
                    </p>
                </div>
                <div class="schedule-column">
                    <h3>Dub Night</h3>
                    <p class="time">THURSDAYS 8pm - 10pm</p>
                    <p>
                        A heavyweight session dedicated to DUB lovers around the world. Expect classics from the 2000s mixed
                        in with heart-stopping heavyweights from dub producers of today, including King Earthquake Productions.
                        Make sure you’re plugged into a solid bass box to feel the Thursday night vibrations.
                    </p>
                </div>
            </div>
        </div>
        <div id="book-promo" class="section home">
            <img src="/public/assets/images/products/book-cover.png" alt="Book Cover" class="desktop" />
            
            <div class="details">
                <h2>Look out for the new book!</h2>
                
                <div class="image mobile tablet">
                    <img src="/public/assets/images/products/book-cover-mobile.png" alt="Book Cover" />
                </div>
                
                <p class="center">
                    Prejudice, Pain and Praise tells the powerful true story of King Earthquake’s journey through sound
                    system culture. From building heavyweight systems to facing prejudice, hardship, and personal trials,
                     the book shares honest experiences from over four decades in music, culture, and community showing
                      how sound system carried him through struggle, purpose, and faith.<br/>
                </p>
                
                <div id="book-interest-success" class="buttons">
                    <a href="https://www.amazon.co.uk/dp/1918465312" target="_blank"><button>View on Amazon</button></a>
                </div>
            </div>
        </div>
        <div class="section home next-event lighter-2">
            <h2>Next Event</h2>
            <div class="event">
                <div class="details">
                    <h3>Black British Book Festival 2026</h3>
                                    
                    <div class="info">
                        <span><i class="fas fa-clock"></i>4th October 2026 12pm - 7pm</span>
                        <span><i class="fas fa-location-pin"></i>London, UK</span>
                    </div>
                    
                    <div class="buttons">
                        <a href="https://www.blackbritishbookfestival.com/" target="_blank"><button>Find out More</button></a>
                    </div>
                </div>
                <a href="https://www.blackbritishbookfestival.com" target="_blank">
                    <img src="/public/assets/images/events/2026/10-04-BBBF.jpeg" alt="Black British Book Festival Poster" />
                </a>
            </div>
        </div>
        <div class="section home lighter-1">
            <h2>A stepping stone to producing your own music.</h2>
            <p class="center">
                Find out how Errol Arawak produces music the King Earthquake way.
            </p>
            <div class="buttons">
            <a href="https://courses.king-earthquake.com/"><button>Find out more</button></a>
            </div>
        </div>
    `,

    _ketv_status_unsubscribe: null,

    updateKetvElements(online) {
        const offlineElements = document.querySelectorAll('.offline');
        const onlineElements = document.querySelectorAll('.online');

        if (online === true) {
            offlineElements.forEach(el => el.classList.add('hidden'));
            onlineElements.forEach(el => el.classList.remove('hidden'));
        } else {
            offlineElements.forEach(el => el.classList.remove('hidden'));
            onlineElements.forEach(el => el.classList.add('hidden'));
        }
    },

    onMount() {
        this._scroll_to_timetable = (event) => {
            event.preventDefault();
            event.stopPropagation();

            const $timetable = document.getElementById("ketv-timetable");
            if ($timetable) {
                const headerOffset = 80;
                const y = $timetable.getBoundingClientRect().top + window.scrollY - headerOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }

        const $hero_button = document.getElementById("HeroButton");
        if ($hero_button) {
            $hero_button.addEventListener("click", this._scroll_to_timetable);
        }

        const $scrollDown = document.getElementById("ScrollDown");
        if ($scrollDown) {
            $scrollDown.addEventListener("click", this._scroll_to_timetable);
        }

        this.updateKetvElements(store.get('ketv')['online'])

        this._ketv_status_unsubscribe = store.subscribe('ketv', (ketvState) => {
            this.updateKetvElements(ketvState.online)
        });
    },

    onUnmount() {
        if (this._scroll_to_timetable) {
            const $hero_button = document.getElementById("HeroButton");
            if ($hero_button) {
                $hero_button.removeEventListener("click", this._scroll_to_timetable);
            }

            const $scrollDown = document.getElementById("ScrollDown");
            if ($scrollDown) {
                $scrollDown.removeEventListener("click", this._scroll_to_timetable);
            }
        }

        if (this._ketv_status_unsubscribe) this._ketv_status_unsubscribe();
    },
};
